import React from "react";

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-white/50">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-[11px] text-white/40">{hint}</span>}
  </label>
);

export const Input = ({ className = "", ...props }) => (
  <input
    {...props}
    className={`w-full rounded-lg border border-white/10 bg-[#0B1020] px-4 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-fuchsia-500/50 focus:outline-none ${className}`}
  />
);

export const Textarea = ({ className = "", ...props }) => (
  <textarea
    {...props}
    className={`w-full rounded-lg border border-white/10 bg-[#0B1020] px-4 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-fuchsia-500/50 focus:outline-none ${className}`}
  />
);

export const SaveBar = ({ onSave, saving, children }) => (
  <div className="sticky bottom-0 mt-8 flex items-center justify-between gap-3 rounded-xl border border-white/10 bg-[#0F1528]/90 p-4 backdrop-blur">
    <div className="text-xs text-white/50">{children}</div>
    <button
      onClick={onSave}
      disabled={saving}
      data-testid="admin-save-btn"
      className="group relative inline-flex items-center gap-2 rounded-full px-6 py-2.5 text-xs font-semibold text-white disabled:opacity-60"
    >
      <span className="absolute inset-0 rounded-full gradient-bg" />
      <span className="relative">{saving ? "Saving…" : "Save changes"}</span>
    </button>
  </div>
);
